module.exports = "img/flags/BS.8699015.png";